import "print-js/dist/print";

$(function() {
  $(".js-print").click(function(e) {
    e.preventDefault();

    printJS($(this).attr("href"));
  });
});
